import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { AbilityContext } from './AbilityContext';
import ability from './PublicAbility';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'ionicons/dist/css/ionicons.css';
import './assets/css/bootstrapoverrides.scss';
import './assets/css/smiley.scss';
// Import as a module in your JS
import 'react-bootstrap-typeahead/css/Typeahead.css';

ReactDOM.render(
  <AbilityContext.Provider value={ability}>
    <App />
  </AbilityContext.Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
